import React from 'react';
import './EmptyState.less';

/**
 * EmptyState — the "no data yet" pattern for a section body.
 *
 *   - orientation="horizontal" (default): icon on the left, text in
 *     the middle, optional action on the right. Reads as designed
 *     content rather than a placeholder. Stacks vertically on mobile.
 *   - orientation="vertical"  : icon on top, text centred, action
 *     below. Use only when the surface is genuinely narrow.
 */
function EmptyState({
  icon,
  title,
  description,
  action,
  orientation = 'horizontal',
}) {
  return (
    <div className={`gc-empty gc-empty-${orientation}`} role="status">
      {icon && <div className="gc-empty-icon" aria-hidden="true">{icon}</div>}
      <div className="gc-empty-text">
        {title && <h3 className="gc-empty-title">{title}</h3>}
        {description && <p className="gc-empty-desc">{description}</p>}
      </div>
      {action && <div className="gc-empty-action">{action}</div>}
    </div>
  );
}

export default EmptyState;
